import { Separator } from 'components/ui/separator';
import { ClassifierData } from 'types/classifiers';
import { InvoiceMinDto } from 'types/invoices';
import InvoiceItem from './InvoiceItem';

type Props = {
    invoices: InvoiceMinDto[];
    classifiers: Record<string, ClassifierData>;
};

const TimeCardInvoiceList: React.FC<Props> = ({ invoices, classifiers }) => {
    if (!invoices || invoices.length === 0) {
        return <div>-</div>;
    }

    return (
        <div className="flex w-full flex-col">
            {invoices.map((invoice, index) => (
                <div key={invoice.id}>
                    <InvoiceItem classifiers={classifiers} invoice={invoice} />
                    {index < invoices.length - 1 && <Separator className="my-3" />}
                </div>
            ))}
        </div>
    );
};

export default TimeCardInvoiceList;
